var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('order-summary-line',{attrs:{"value":_vm.price,"semi-bold":false},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v("\n\t\t"+_vm._s(_vm.item.name)+":\n\t")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }